<template>
  <v-dialog v-model="dialog" max-width="960px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-8 text-center subtitle-1">
        <v-card v-if="album && album.length > 0">
          <v-carousel hide-delimiters cycle>
            <v-carousel-item
              v-for="(item, i) in album"
              :key="i"
              :src="item"
              @click.stop="$showFullscreenImages(album, i)"
            >
              <v-tooltip right v-if="item">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="pa-2 float-right"
                    @click.stop="removeFromImages(i)"
                  >fa-times
                  </v-icon>
                </template>
                <span> {{ $t("Dish.delImg") }}</span>
              </v-tooltip>
            </v-carousel-item>
          </v-carousel>
        </v-card>
        <!-- 上传质检报告 -->
        <v-file-input
          ref="img_file"
          show-size
          counter
          small-chips
          suffix
          multiple
          prepend-icon="fa-camera"
          accept="image/png, image/jpeg"
          persistent-hint
          :placeholder="$t('Material.imgsPlaceholder')"
          :hint="$t('Material.imgsHint')"
          :rules="imgRules"
          v-model="img_file"
          v-if="editEnable"
        >
        </v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" depressed :disabled="uploading" @click="uploading = true;addComfirm();">
          {{ $t("$vuetify.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import Files from "@/api/files";
import Receipt from "@/api/receipt";

export default {
  name: "DialogPostImages",

  props: {
    value: Boolean,
    img_url: Array,
    editEnable: Boolean,
    folder_type: String,
    title: String,
    billRecordId: Number,
  },

  data: () => ({
    dialog: false,
    imgRules: [(value) => !value || value.filter((v) => v.size >= 10000000).length == 0 || i18n.t("Material.imgsHint")],
    img_file: null,
    album: [],
    uploading: false,
    changeFlg: false,
  }),

  methods: {
    async addComfirm() {
      if (this.img_file && this.img_file.length > 0) {
        // 选择了新文件，上传后更新图片
        let response = await Files.imagesUpload(this.img_file, false, this.folder_type);
        if (response.data.status.isOK()) {
          this.saveAlbumImgs(response.data.data)
        }
      } else if (this.changeFlg) {
        // 删除了图片
        let imgs = [];
        if (this.album && this.album.length > 0) {
          this.album.map((img) => {
            imgs.push({
              img_name: img.substring(img.lastIndexOf('/') + 1)
            })
          })
        }
        this.saveAlbumImgs(imgs)
      } else {
        this.uploading = false;
        this.dialog = false;
      }
    },
    saveAlbumImgs(images) {
      this.$store.dispatch("fullscreenLoading");
      let data = {
        bill_record_id: this.billRecordId,
        imgs: []
      }
      if (images && images.length >0) {
        data.imgs = images.map((img) => img.img_name)

      }
      Receipt.uploadImg(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("ReceiptDetail.cancelRefundSuccess"));
            }
            this.$store.dispatch("fullscreenLoadingStop");
            this.$emit("addComfirm", []);
            this.uploading = false;
            this.dialog = false;
          }.bind(this)
      )
    },
    removeFromImages(i) {
      this.changeFlg = true;
      this.album.splice(i, 1);
      if (this.img_file) {
        this.img_file.splice(i, 1);
      }
    },
  },

  mounted() {},

  watch: {
    value: {
      immediate: true,
      handler() {
        this.album = [];
        if (this.img_url && this.img_url.length > 0) {
          this.album = this.img_url.map((img) => {
            if (img.img_url) {
              return img.img_url
            } else {
              return img
            }
          });
        }
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.img_file = null;
          this.album = [];
        }
      },
    },
    img_file: {
      deep: true,
      handler() {
        this.album = [];
        if (this.img_file) {
          if (this.img_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.img_file = [];
          }else {
            this.img_file.forEach((img, i) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.splice(i, 0, this.result);
              };
            });
          }
        }
      },
    },
  },
};
</script>
